const insuranceProducts = [
  {
    title: "Term Life Insurance",
    description: "Protect your family's future with large cover and flexible premiums.",
    icon: "TL",
    accent: "from-peach to-orange-300",
  },
  {
    title: "Health Insurance",
    description: "Cashless hospitalization, wellness benefits, and top-up options.",
    icon: "HI",
    accent: "from-mint to-emerald-400",
  },
  {
    title: "Motor Insurance",
    description: "Instant quotes for car and bike plans with 24x7 claim assistance.",
    icon: "MI",
    accent: "from-sky to-cyan-400",
  },
  {
    title: "Travel Insurance",
    description: "Global protection for medical emergencies, trip delays, and baggage loss.",
    icon: "TR",
    accent: "from-amber to-yellow-400",
  },
];

const benefits = [
  "Compare top insurers in under 60 seconds",
  "Personalized recommendations by life stage",
  "Fast renewals and claim support from real advisors",
  "Trusted by 2M+ families across India",
];

const stats = [
  { value: "48+", label: "Insurance partners" },
  { value: "98%", label: "Renewal retention" },
  { value: "30 min", label: "Average advisor callback" },
  { value: "4.8/5", label: "Customer happiness score" },
];

const plans = [
  {
    title: "Care Plus",
    price: "Starts at Rs 612/mo",
    blurb: "Best for young families who want health + life cover together.",
    features: ["10L health cover", "1Cr term life", "Free annual health checkup"],
  },
  {
    title: "Drive Smart",
    price: "Starts at Rs 3,249/yr",
    blurb: "Perfect for car owners who want zero-dep and roadside support.",
    features: ["Zero depreciation", "24x7 towing", "Garage network across 650+ cities"],
  },
  {
    title: "Retire Assured",
    price: "Starts at Rs 1,850/mo",
    blurb: "For long-term wealth building with pension-ready stability.",
    features: ["Guaranteed returns", "Tax benefits", "Flexible payout options"],
  },
];

const reviews = [
  {
    name: "Ritika Mehra",
    role: "New parent, Pune",
    quote: "The comparison flow felt clear and calm. We picked a family floater plan in one evening.",
  },
  {
    name: "Aman Verma",
    role: "Car owner, Noida",
    quote: "Renewal was faster than any aggregator I have used before, and the callback team was actually helpful.",
  },
  {
    name: "Deepak Iyer",
    role: "Frequent traveler, Bengaluru",
    quote: "I liked that the plans were explained in plain language instead of pushing me into the cheapest option.",
  },
];

const faqs = [
  {
    question: "Can I compare plans without entering my phone number?",
    answer: "Yes. You can browse product categories and pricing ranges first, then share details only when you want a custom quote.",
  },
  {
    question: "Do you support policy renewals from other insurers?",
    answer: "Yes. The renewal flow is designed to help switch or continue coverage with minimal paperwork.",
  },
  {
    question: "How quickly can I get help during a claim?",
    answer: "Our claims desk is available every day and priority callbacks are scheduled within minutes for active customers.",
  },
];

window.AppData = window.AppData || {};
window.AppData.siteContent = {
  benefits,
  faqs,
  insuranceProducts,
  plans,
  reviews,
  stats,
};
